import { FlaskConical } from 'lucide-react'

import { useAuth } from '@/lib/api/auth'

/**
 * Always visible while the app talks to the test environment, so nobody
 * mistakes demo tickets for real kitchen traffic.
 */
export function TestModeBanner() {
  const { mode, session, ready } = useAuth()
  const activeMode = session?.mode ?? mode
  if (!ready || activeMode !== 'test') return null

  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-testmode px-4 py-1.5 text-center text-xs font-semibold uppercase tracking-[0.18em] text-testmode-foreground">
      <FlaskConical className="h-3.5 w-3.5" aria-hidden />
      <span>Test mode — all data is demo data</span>
    </div>
  )
}
